.TabPanel {
  border-radius: var(--radius-sm);
  padding: var(--space-sm);
  background: var(--bg);

  &:first-of-type {
    border-radius: 0 var(--radius-sm) var(--radius-sm) var(--radius-sm);
  }
}
